// extracted by mini-css-extract-plugin
export default {"scoreContainer":"MultipleScoreComponent_scoreContainer__Lln7A","header":"MultipleScoreComponent_header__n7DT-","options":"MultipleScoreComponent_options__zx76g"};